// Swipe Mode Hook
// Manages swipe mode state and interactions

import { useState, useCallback } from "react";
import { 
  FeedItem, 
  SwipeAction, 
  SwipeDirection, 
  UseSwipeModeReturn 
} from "../../types/socialFeed";
import { swipeModeService } from "../../services/SocialFeed/swipeModeService";

export const useSwipeMode = (): UseSwipeModeReturn => {
  const [isSwipeModeActive, setIsSwipeModeActive] = useState(false);
  const [currentSwipeItem, setCurrentSwipeItem] = useState<FeedItem | null>(null);
  const [swipeHistory, setSwipeHistory] = useState<SwipeAction[]>([]);

  const openSwipeMode = useCallback((item: FeedItem) => {
    setCurrentSwipeItem(item);
    setIsSwipeModeActive(true);
  }, []);

  const closeSwipeMode = useCallback(() => {
    setIsSwipeModeActive(false);
    setCurrentSwipeItem(null);
  }, []);

  const handleSwipe = useCallback(
    async (direction: SwipeDirection) => {
      if (!currentSwipeItem) return;

      const swipeAction: SwipeAction = {
        itemId: currentSwipeItem.id,
        userId: currentSwipeItem.userId,
        direction,
        timestamp: new Date(),
        compatibilityScore: currentSwipeItem.metadata?.compatibilityScore,
      };

      try {
        await swipeModeService.recordSwipe(swipeAction);
        setSwipeHistory((prev) => [...prev, swipeAction]);

        // Close swipe mode after successful swipe
        closeSwipeMode();
      } catch (error) {
        console.error("Failed to record swipe:", error);
      }
    },
    [currentSwipeItem, closeSwipeMode]
  );

  return {
    isSwipeModeActive,
    currentSwipeItem,
    swipeHistory,
    openSwipeMode,
    closeSwipeMode,
    handleSwipe,
  };
};
